module.exports = __webpack_public_path__ + "img/galardon.3b641ac8.png";